import { render, staticRenderFns } from "./WhatsInput.vue?vue&type=template&id=98f36710&scoped=true"
import script from "./WhatsInput.vue?vue&type=script&lang=js"
export * from "./WhatsInput.vue?vue&type=script&lang=js"
import style0 from "./WhatsInput.vue?vue&type=style&index=0&id=98f36710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f36710",
  null
  
)

export default component.exports